// extracted by mini-css-extract-plugin
export var absoluteContentContainer = "stacks-module--absoluteContentContainer--5f56e";
export var alignBottom = "stacks-module--alignBottom--3faca";
export var alignCenter = "stacks-module--alignCenter--8f44b";
export var alignTop = "stacks-module--alignTop--f05cd";
export var bottom = "stacks-module--bottom--f9fea";
export var center = "stacks-module--center--f4ec3";
export var contentContainer = "stacks-module--contentContainer--834d8";
export var eightFour = "stacks-module--eightFour--c69c7";
export var fillStacksToFullHeight = "stacks-module--fillStacksToFullHeight--7b63f";
export var fiveSeven = "stacks-module--fiveSeven--5fa75";
export var fourEight = "stacks-module--fourEight--599c7";
export var gapColor = "stacks-module--gapColor--592ca";
export var hideOnMobile = "stacks-module--hideOnMobile--541c6";
export var image = "stacks-module--image--d62b2";
export var imageContainer = "stacks-module--imageContainer--8d553";
export var justifyCenter = "stacks-module--justifyCenter--af357";
export var justifyLeft = "stacks-module--justifyLeft--77728";
export var justifyRight = "stacks-module--justifyRight--ab74b";
export var moduleContainer = "stacks-module--moduleContainer--b113e";
export var portableText = "stacks-module--portableText--93954";
export var reactPlayer = "stacks-module--reactPlayer--37831";
export var reverseDirectionOnMobile = "stacks-module--reverseDirectionOnMobile--ec4f6";
export var selfVertical = "stacks-module--selfVertical--a8078";
export var sevenFive = "stacks-module--sevenFive--6cf86";
export var sixSix = "stacks-module--sixSix--9aad5";
export var spanEightColumns = "stacks-module--spanEightColumns--fd17f";
export var spanSixColumns = "stacks-module--spanSixColumns--44542";
export var spanTenColumns = "stacks-module--spanTenColumns--64b6e";
export var spanTwelveColumns = "stacks-module--spanTwelveColumns--aec23";
export var stackContainer = "stacks-module--stackContainer--de61f";
export var stackIndex0 = "stacks-module--stackIndex0--2c7c2";
export var stackIndex1 = "stacks-module--stackIndex1--7ccf9";
export var stacksContainer = "stacks-module--stacksContainer--7e2a1";
export var stickyColumn = "stacks-module--stickyColumn--e7698";
export var tocPlusFourFour = "stacks-module--tocPlusFourFour--20fa0";
export var tocPlusThreeFive = "stacks-module--tocPlusThreeFive--bba82";
export var tocSpanEightColumns = "stacks-module--tocSpanEightColumns--1c2ad";
export var top = "stacks-module--top--b1df0";
export var twoSpanTenColumns = "stacks-module--twoSpanTenColumns--bfd05";
export var twoSpanTwelveColumns = "stacks-module--twoSpanTwelveColumns--9bdaa";